/**
 * Check if a string is a valid email address.
 */
export const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

/**
 * Check if a string is a valid URL (http or https).
 */
export const isValidUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

/**
 * Check if a string is a valid 3 or 6 digit hex colour (case-insensitive).
 * Matches the backend HEX_REGEX used across storefront_design validation.
 */
export const isValidHexColor = (value: string): boolean =>
  /^#([a-f0-9]{6}|[a-f0-9]{3})$/i.test(value);

/**
 * Check if a string is a valid font name. Matches the backend FONT_NAME_REGEX
 * used for theme font fields — alphanumerics and spaces only, no punctuation.
 */
export const isValidFontName = (value: string): boolean =>
  /^[a-zA-Z0-9 ]+$/.test(value);
